import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GeneralDataContextProvider } from './context/general-data-context';
import { PlannerContextProvider } from './context/planner-context';
import { NotificationContextProvider } from './context/notification-context';
import { UserContextProvider } from './context/user-context';
import { CacheApiContextProvider } from './context/cache-api-context';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import { TourContextProvider } from './context/tour-context';
import { ChatContextProvider } from './context/chat-context';
import { ResilientAxiosProvider } from './network/ResilientAxiosContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ErrorBoundary>
        <ResilientAxiosProvider>
          <TourContextProvider>
            <NotificationContextProvider>
              <UserContextProvider>
                <CacheApiContextProvider>
                  <GeneralDataContextProvider>
                      <ChatContextProvider>
                        <PlannerContextProvider>
                          <App />
                        </PlannerContextProvider>
                      </ChatContextProvider>
                  </GeneralDataContextProvider>
                </CacheApiContextProvider>
              </UserContextProvider>
            </NotificationContextProvider>
          </TourContextProvider>
        </ResilientAxiosProvider>
    </ErrorBoundary>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
